import { render, staticRenderFns } from "./rightData.vue?vue&type=template&id=864b2c96&scoped=true"
import script from "./rightData.vue?vue&type=script&lang=js"
export * from "./rightData.vue?vue&type=script&lang=js"
import style0 from "./rightData.vue?vue&type=style&index=0&id=864b2c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864b2c96",
  null
  
)

export default component.exports